import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({
  message = 'Indlæser...',
  subtitle = '',
  size = 'medium',
  className = '',
  showMessage = true,
  fill = false,
  overlay = false,
  eyebrow = '',
}) => {
  const rootClassName = [
    'app-loading',
    fill ? 'app-loading--fill' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const content = (
    <div className={rootClassName} role="status" aria-live="polite">
      {eyebrow ? <p className="app-loading__eyebrow">{eyebrow}</p> : null}
      <div className={`app-loading__spinner app-loading__spinner--${size}`} aria-hidden="true" />
      {showMessage && message ? <p className="app-loading__message">{message}</p> : null}
      {subtitle ? <p className="app-loading__message app-loading__message--body">{subtitle}</p> : null}
    </div>
  );

  if (overlay) {
    return <div className="app-loading-overlay">{content}</div>;
  }

  return content;
};

export default LoadingSpinner;
